import { render, staticRenderFns } from "./CreateOrganizationNews.vue?vue&type=template&id=1a43e11f"
import script from "./CreateOrganizationNews.vue?vue&type=script&lang=js"
export * from "./CreateOrganizationNews.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganizationNews.vue?vue&type=style&index=0&id=1a43e11f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports